import { makeActionCreator } from '../../config/store/utils'

export const OPEN_QUOTE_BID_SEE_DETAIL_DIALOG = 'OPEN_QUOTE_BID_SEE_DETAIL_DIALOG'
export const onOpenQuoteBidSeeDetailDialog = makeActionCreator(OPEN_QUOTE_BID_SEE_DETAIL_DIALOG, 'payload')

export const CLOSE_QUOTE_BID_SEE_DETAIL_DIALOG = 'CLOSE_QUOTE_BID_SEE_DETAIL_DIALOG'
export const onCloseQuoteBidSeeDetailDialog = makeActionCreator(CLOSE_QUOTE_BID_SEE_DETAIL_DIALOG)
